import { PositionsIcon } from "@/components/icons";

import { POSITIONS } from "./catalog.ts";
import { CatalogPanel } from "./CatalogPanel.tsx";

/**
 * Administración de cargos.
 *
 * El cargo sustituye al rol de la vinculación, que era un enum cerrado en el
 * código. Es PLANO --sin jerarquía-- por decisión explícita, así que aquí no
 * hay ni nivel ni cargo superior: esa es toda la diferencia con lo que había.
 */
export function PositionsPanel() {
  return <CatalogPanel catalog={POSITIONS} icon={PositionsIcon} />;
}
